import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import Input from 'Components/Atoms/Input/Input';

export default function RHFInput({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => <Input {...field} error={error?.message} {...other} />}
        />
    );
}

RHFInput.propTypes = {
    name: PropTypes.string,
};
